import { render, staticRenderFns } from "./RawJSON.vue?vue&type=template&id=1c4dcc2c&"
import script from "./RawJSON.vue?vue&type=script&lang=js&"
export * from "./RawJSON.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports